import { useLoadingStore } from "../store/loadingStore";

export default function LoadingService(){
    const loadingStore = useLoadingStore();
    function ShowLoading(message: string) {
        loadingStore.message = message;
        loadingStore.setShow(true);
    }
    function HiddenLoading(){
        loadingStore.message = '';
        loadingStore.setShow(false);
    }

    return {
        ShowLoading,
        HiddenLoading,
    };
} 